<h4 class="headline">{{ 'recipe.ingredients' | translateSafe }}</h4>
<div class="ingredient-section" *ngFor="let ingredientSection of ingredientSections">
    <h5>{{ ingredientSection.ingredientListHeading }}</h5>
    <ul>
        <li *ngFor="let ingredient of ingredientSection.ingredientsList">
            <span *ngIf="ingredient.amount && ingredient.amount > 0">{{ ingredient.amount }} </span>
            <span *ngIf="ingredient.unit">{{ ingredient.unit }} </span>
            <span>{{ ingredient.ingredientName }}</span>
        </li>
    </ul>
</div>
